export const FOCUS_TRANSITION = {
    duration: 0.15,
    timingFunction: "ease-out",
};
export const UNFOCUSED_ROW_ALPHA = 0.4;
//# sourceMappingURL=focus.js.map